import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'

export class DriverShiftFilterEntity {
  shiftId?: string
  driver?: DriverEntity
  page?: number
  limit?: number
  createdAtFrom?: string
  createdAtTo?: string
}
